import React, { createContext, useContext, useState, useCallback } from 'react';

const MapReadyContext = createContext({ mapReady: false, setMapReady: () => {} });

export const useMapReady = () => useContext(MapReadyContext);

export const MapReadyProvider = ({ children }) => {
  const [mapReady, setMapReady] = useState(false);
  return (
    <MapReadyContext.Provider value={{ mapReady, setMapReady }}>
      {children}
    </MapReadyContext.Provider>
  );
};

export default MapReadyContext;
